module.exports = __webpack_public_path__ + "img/edit_focus.0ae7e54.svg";